module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-sharp-duotone-solid-900.woff2";